import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  & + & {\n    margin-top: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  list-style: none;\n  margin: 0;\n  padding: ", "px 0;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { typography, size } from '@scp/ui-shared/theme/variables';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
export var listBase = css(_templateObject(), function (props) {
  return props.primary ? typography.fontWeightSemiBold : typography.fontWeightNormal;
}, function (props) {
  return props.noSpacing ? 0 : size.gutterSmall / 2;
});
export var listItemBase = css(_templateObject2(), function (props) {
  return props.primary ? baselineToPx(2) : 0;
});